import React from "react";
import PropTypes from "kf-proptypes/widgets";

import { SWITCH_TYPES, Switch, SWITCH_SIZES } from "@widgets/inputs/index.jsx";

import styles from "./styles.css";

InlineToggle.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  className: PropTypes.string
};

export function InlineToggle({ label, value, onChange, disabled, className }) {
  return (
    <div className={`${styles.toggleContainer} ${className}`}>
      <p className={`small ellipsis ${styles.label}`}>{label}</p>
      <Switch
        type={SWITCH_TYPES.GREEN}
        value={value}
        disabled={disabled}
        onChange={onChange}
        size={SWITCH_SIZES.TINY}
      />
    </div>
  );
}
